import { render, staticRenderFns } from "./skills.vue?vue&type=template&id=66cd38b0&"
import script from "./skills.vue?vue&type=script&lang=js&"
export * from "./skills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports